@import "../../scss";

.root {
  background: var(--color-cream);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1.25rem;
  text-transform: uppercase;
  color: var(--color-bright-green);
  pointer-events: none;
  padding: var(--spacer-4);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  opacity: 0;
  @include typo--instruction();

  @include media-breakpoint-down("md") {
    white-space: nowrap;
  }
}

.root svg {
  margin-bottom: 1.5rem;
}

.root--is-visible {
  opacity: 1;
}

.escape-to-exit {
  position: fixed;
  bottom: var(--spacer-4);
  right: var(--spacer-4);
  display: flex;
  align-items: baseline;
  justify-content: center;
  text-transform: uppercase;
  color: var(--color-cream);
  white-space: break-spaces;
  line-height: 1;
  @include typo--small-label();
  transition: opacity 1s ease;
  opacity: 0;
}

.escape-to-exit--is-visible {
  opacity: 1;
}

.escape-to-exit__esc {
  display: inline-block;
  border: 1px solid var(--color-cream);
  padding: 0.25rem 0.25rem 0.3rem 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.pointer-icon {
  width: 2.625rem;
  height: auto;
}
